<h2>{{cardConfiguration.title}}</h2>

<ng-container *ngIf="isVersion2()">
<div class="row">
  <div class="col-sm-8">
    <div class="form-group">
      <label for="Name" [class.disabled]="certifiedData?.identificationData?.idenCertification === 'S'"><span class="mandatory">*</span>{{'CardSubscriberIdentification.Name' | translate}}</label>
      <input class="form-control" type="text" placeholder="{{'Placeholders.CardSubscriberIdentification.Name' | translate}}" [(ngModel)]="cardData.name" [disabled]="certifiedData?.identificationData?.idenCertification === 'S'" name="name" #name="ngModel" maxlength="60" required>
      <validation-message [control]="name"></validation-message>
    </div>
  </div>
  <div class="col-sm-4">
    <div class="form-group">
      <label [ngClass]="!dateOfBirth ? '' : 'disabled' ">{{'CardSubscriberIdentification.DateOfBirth' | translate}}</label>
      <div class="input-group">
        <input #dpDateOfBirth="bsDatepicker" bsDatepicker
               type="text"
               class="form-control DatepickerCustomClasse"
               [bsConfig]="{ dateInputFormat: 'YYYY-MM-DD', containerClass: 'theme-default', showWeekNumbers:false }"
               [(ngModel)]="cardData.dateOfBirth" name="dateOfBirth" #dateOfBirth="ngModel" maxlength="10" disabled
               (keyup)="formatDate($event)" (keydown)="onlyNumbers($event)" >
        <div class="input-group-append disable-on-fieldset" (click)="!dpDateOfBirth.isDisabled && dpDateOfBirth.toggle()">
          <span class="input-group-text">
            <i class="icon-calendar"></i>
          </span>
        </div>
        <validation-message [control]="dateOfBirth"></validation-message>
      </div>
    </div>
  </div>
</div>
<div class="row" *ngIf="parentWorkflow.workflowInstance.workflowCode.indexOf('PEDI008B') == -1">
  <div class="col-sm-4">
    <div class="form-group">
      <label for="Nationality" [class.disabled]="certifiedData?.identificationData?.idenCertification === 'S'"><span class="mandatory">*</span>{{'CardSubscriberIdentification.Nationality' | translate}}</label>
      <select class="custom-select" [(ngModel)]="cardData.nationalityCode" [disabled]="certifiedData?.identificationData?.idenCertification === 'S'" name="nationalityCode" #nationalityCode="ngModel" required
              [dropdownTitle]="{value : cardData.nationalityCode , dimension : nationalities }" nullableSelect>
        <default-dropdown-values></default-dropdown-values>
        <option *ngFor="let domain of nationalities" [value]="domain.code">
          {{domain.description}}
        </option>
      </select>
      <validation-message [control]="nationalityCode"></validation-message>
    </div>
  </div>
  <div class="col-sm-4">
    <div class="form-group">
      <label for="Gender"><span class="mandatory">*</span>{{'CardSubscriberIdentification.Gender' | translate}}</label>
      <select class="custom-select" [(ngModel)]="cardData.genderCode" name="genderCode" #genderCode="ngModel" required
              [dropdownTitle]="{value : cardData.genderCode, dimensions :  genders }" nullableSelect>
        <default-dropdown-values></default-dropdown-values>
        <option *ngFor="let domain of genders" [value]="domain.code">
          {{domain.description}}
        </option>
      </select>
      <validation-message [control]="genderCode"></validation-message>
    </div>

  </div>
  <div class="col-sm-4">
    <div class="form-group">
      <label for="MaritalStatus"><span class="mandatory">*</span>{{'CardSubscriberIdentification.MaritalStatus' | translate}}</label>
      <select class="custom-select" [(ngModel)]="cardData.maritalStatusCode" name="maritalStatusCode" #maritalStatusCode="ngModel" required
              [dropdownTitle]="{value : cardData.maritalStatusCode, dimensions :  maritalStatuses }" nullableSelect>
        <default-dropdown-values></default-dropdown-values>
        <option *ngFor="let domain of maritalStatus" [value]="domain.description" [disabled]="disableMaritalStatusOptions(domain.description)" [ngStyle]="{'font-weight': !disableMaritalStatusOptions(domain.description) === false && domain.description === 'UF' ? 'bold' : ''}">
          {{domain.value}}
        </option>
      </select>
      <validation-message [control]="maritalStatusCode"></validation-message>
    </div>
  </div>
</div>

<div class="row" *ngIf="parentWorkflow.workflowInstance.workflowCode.indexOf('PEDI008B') == -1">
  <div class="col-sm-4">
    <div class="form-group">
      <label for="DocumentType" class="disabled">{{'CardSubscriberIdentification.DocumentType' | translate}}</label>
      <select class="custom-select" [(ngModel)]="cardData.documentTypeCode" name="documentTypeCode" #documentTypeCode="ngModel" disabled
              [dropdownTitle]="{value : cardData.documentTypeCode, dimensions : documentTypes }" nullableSelect>
        <default-dropdown-values></default-dropdown-values>
        <option *ngFor="let domain of documentTypes" [value]="domain.code">
          {{domain.description}}
        </option>
      </select>
      <validation-message [control]="documentTypeCode"></validation-message>
    </div>
  </div>
  <div class="col-sm-4">
    <div class="form-group">
      <label for="IdentificationNumber" class="disabled">{{'CardSubscriberIdentification.IdentificationNumber' | translate}}</label>
      <div class="form-row">
        <div class="col-sm-9">
          <input class="form-control" type="text" [(ngModel)]="cardData.identificationNumber" name="identificationNumber" #identificationNumber="ngModel" maxlength="8" disabled>
          <validation-message [control]="identificationNumber"></validation-message>
        </div>
        <div class="col-sm-3">
          <input class="form-control" type="text" numeric="1" [(ngModel)]="cardData.verificationNumber" name="verificationNumber" #verificationNumber="ngModel" minValue="1" maxValue="9" disabled>
          <validation-message [control]="verificationNumber"></validation-message>
        </div>
      </div>
    </div>
  </div>
  <div class="col-sm-4">
    <div class="form-group">
      <label for="FiscalNumber" class="disabled">{{'CardSubscriberIdentification.FiscalNumber' | translate}}</label>
      <input class="form-control" type="text" numeric="9" [(ngModel)]="cardData.fiscalNumber" name="fiscalNumber" #fiscalNumber="ngModel" maxlength="9" disabled>
      <validation-message [control]="fiscalNumber"></validation-message>
    </div>
  </div>
</div>
<div class="row" *ngIf="parentWorkflow.workflowInstance.workflowCode.indexOf('PEDI0020') == -1 && parentWorkflow.workflowInstance.workflowCode.indexOf('PEDI008') == -1">
  <div class="col-sm-12">
    <div class="form-group">
      <label for="TaxServiceCode">
        Serviço de finanças
        <span tabindex="0" class="ml-1 text-primary icon-help" aria-label="Tooltip com informação" tooltip="Pode consultar o código do Serviço de Finanças no Portal das Finanças."></span>
      </label>
      <div class="form-row">
        <div class="col-sm-2">
          <input class="form-control" type="text" numeric="4" [(ngModel)]="cardData.taxServiceCode1" name="taxServiceCode1" #taxServiceCode1="ngModel" maxlength="4" (ngModelChange)="onTaxServiceCodeChanged()">
        </div>
        <div class="col-sm-10">
          <input class="form-control" type="text" maxlength="60" [(ngModel)]="cardData.taxServiceCode2" name="taxServiceCode2" #taxServiceCode2="ngModel" disabled>
        </div>
      </div>
      <validation-message *ngIf="taxServiceFound !== false" [control]="taxServiceCode1"></validation-message>
      <h6 *ngIf="taxServiceFound === false" class="invalid-feedback">Código de Serviço de finanças inválido</h6>
    </div>
  </div>
</div>
<div class="row" *ngIf="parentWorkflow.workflowInstance.workflowCode.indexOf('PEDI0020') == -1 && parentWorkflow.workflowInstance.workflowCode.indexOf('PEDI008') == -1">
  <div class="col-sm-4">
    <div class="form-group">
      <label for="Disability">
        <span>Deficiência</span>
      </label>
      <div class="btn-group btn-group-toggle">
        <label *ngFor="let domain of disabilityOptions.slice().reverse()" tabindex="0" class="btn btn-toogle" [class.active]="domain.value==cardData.disability" [radioLabel]="disability">
          <input type="radio" [(ngModel)]="cardData.disability" #disability="ngModel" name="disability" [value]="domain.value"
                 [clearRelated]="{model : this.cardData , propsToReset : ['devalueDegree','disabilityDegree']}">
          {{domain.description}}
        </label>
        <validation-message [message]="'ValidationMessages.required' | translate"></validation-message>
      </div>
    </div>
  </div>
  <div *ngIf="this.cardData.disability?.toString() === 'P' || this.cardData.disability?.toString() === 'T'" class="col-sm-4">
    <div class="form-group">
      <label for="DisabilityDegree"><span class="mandatory">*</span>Grau de desvalorização</label>
      <div class="position-relative">
        <input class="form-control" type="text" percentage
               placeholder="0,00%"
               [(ngModel)]="cardData.disabilityDegree" #disabilityDegree="ngModel" name="disabilityDegree" minValue="0.01" maxValue="100" messageFieldType="percentage" maxlength="6"
               [disabled]="this.cardData.disability === undefined || this.cardData.disability?.toString() === 'N'"
               [required]="this.cardData.disability !== undefined || this.cardData.disability?.toString() !== 'N'">
        <span class="input-icon-span-right">%</span>
        <validation-message [control]="disabilityDegree" [message]="'Valor inserido tem de ser entre 0 e 100.'"></validation-message>
      </div>
    </div>
  </div>
</div>
</ng-container>

<ng-container *ngIf="!isVersion2()">
  <div class="row">
    <div class="col-sm-8">
      <div class="form-group">
        <label for="Name"><span class="mandatory">*</span>{{'CardSubscriberIdentification.Name' | translate}}</label>
        <input class="form-control" type="text" placeholder="{{'Placeholders.CardSubscriberIdentification.Name' | translate}}" [(ngModel)]="cardData.name" name="name" #name="ngModel" maxlength="60" required>
        <validation-message [control]="name"></validation-message>
      </div>
    </div>
    <div class="col-sm-4">
      <div class="form-group">
        <label [ngClass]="!dateOfBirth ? '' : 'disabled' ">{{'CardSubscriberIdentification.DateOfBirth' | translate}}</label>
        <div class="input-group">
          <input #dpDateOfBirth="bsDatepicker" bsDatepicker
                 type="text"
                 class="form-control DatepickerCustomClasse"
                 [bsConfig]="{ dateInputFormat: 'YYYY-MM-DD', containerClass: 'theme-default', showWeekNumbers:false }"
                 [(ngModel)]="cardData.dateOfBirth" name="dateOfBirth" #dateOfBirth="ngModel" maxlength="10" disabled
                 (keyup)="formatDate($event)" (keydown)="onlyNumbers($event)" >
          <div class="input-group-append disable-on-fieldset" (click)="!dpDateOfBirth.isDisabled && dpDateOfBirth.toggle()">
            <span class="input-group-text">
              <i class="icon-calendar"></i>
            </span>
          </div>
          <validation-message [control]="dateOfBirth"></validation-message>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-sm-4">
      <div class="form-group">
        <label for="Nationality"><span class="mandatory">*</span>{{'CardSubscriberIdentification.Nationality' | translate}}</label>
        <select class="custom-select" [(ngModel)]="cardData.nationalityCode" name="nationalityCode" #nationalityCode="ngModel" required
                [dropdownTitle]="{value : cardData.nationalityCode , dimension : nationalities }" nullableSelect>
          <default-dropdown-values></default-dropdown-values>
          <option *ngFor="let domain of nationalities" [value]="domain.code">
            {{domain.description}}
          </option>
        </select>
        <validation-message [control]="nationalityCode"></validation-message>
      </div>
    </div>
    <div class="col-sm-4">
      <div class="form-group">
        <label for="Gender"><span class="mandatory">*</span>{{'CardSubscriberIdentification.Gender' | translate}}</label>
        <select class="custom-select" [(ngModel)]="cardData.genderCode" name="genderCode" #genderCode="ngModel" required
                [dropdownTitle]="{value : cardData.genderCode, dimensions :  genders }" nullableSelect>
          <default-dropdown-values></default-dropdown-values>
          <option *ngFor="let domain of genders" [value]="domain.code">
            {{domain.description}}
          </option>
        </select>
        <validation-message [control]="genderCode"></validation-message>
      </div>

    </div>
    <div class="col-sm-4">
      <div class="form-group">
        <label for="MaritalStatus"><span class="mandatory">*</span>{{'CardSubscriberIdentification.MaritalStatus' | translate}}</label>
        <select class="custom-select" [(ngModel)]="cardData.maritalStatusCode" name="maritalStatusCode" #maritalStatusCode="ngModel" required
                [dropdownTitle]="{value : cardData.maritalStatusCode, dimensions :  maritalStatuses }" nullableSelect>
          <default-dropdown-values></default-dropdown-values>
          <option *ngFor="let domain of maritalStatuses" [value]="domain.code">
            {{domain.description}}
          </option>
        </select>
        <validation-message [control]="maritalStatusCode"></validation-message>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-sm-4">
      <div class="form-group">
        <label for="DocumentType" class="disabled">{{'CardSubscriberIdentification.DocumentType' | translate}}</label>
        <select class="custom-select" [(ngModel)]="cardData.documentTypeCode" name="documentTypeCode" #documentTypeCode="ngModel" disabled
                [dropdownTitle]="{value : cardData.documentTypeCode, dimensions : documentTypes }" nullableSelect>
          <default-dropdown-values></default-dropdown-values>
          <option *ngFor="let domain of documentTypes" [value]="domain.code">
            {{domain.description}}
          </option>
        </select>
        <validation-message [control]="documentTypeCode"></validation-message>
      </div>
    </div>
    <div class="col-sm-4">
      <div class="form-group">
        <label for="IdentificationNumber" class="disabled">{{'CardSubscriberIdentification.IdentificationNumber' | translate}}</label>
        <div class="form-row">
          <div class="col-sm-9">
            <input class="form-control" type="text" [(ngModel)]="cardData.identificationNumber" name="identificationNumber" #identificationNumber="ngModel" maxlength="8" disabled>
            <validation-message [control]="identificationNumber"></validation-message>
          </div>
          <div class="col-sm-3">
            <input class="form-control" type="text" numeric="1" [(ngModel)]="cardData.verificationNumber" name="verificationNumber" #verificationNumber="ngModel" minValue="1" maxValue="9" disabled>
            <validation-message [control]="verificationNumber"></validation-message>
          </div>
        </div>
      </div>
    </div>
    <div class="col-sm-4">
      <div class="form-group">
        <label for="FiscalNumber" class="disabled">{{'CardSubscriberIdentification.FiscalNumber' | translate}}</label>
        <input class="form-control" type="text" numeric="9" [(ngModel)]="cardData.fiscalNumber" name="fiscalNumber" #fiscalNumber="ngModel" maxlength="9" disabled>
        <validation-message [control]="fiscalNumber"></validation-message>
      </div>
    </div>
  </div>
</ng-container>
<!--<pre>{{cardData | json}}</pre>-->
